import { cva } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
import { dayjs, formatDate, MONTH_YEAR } from '@koob/dates';

export function AllotmentButton({
  children,
  onClick,
  type = 'button',
  testId,
  disabled,
  variant = 'secondary',
}) {
  const allotmentButton = cva(
    [
      'w-52 inline-flex items-center justify-center px-4 py-2 text-xs font-medium rounded-md border shadow-sm transition-colors focus:outline-none focus:ring-2 focus:ring-offset-1 active:scale-[.99]',
    ],
    {
      variants: {
        variant: {
          secondary:
            'bg-white text-gray-700 border-gray-300 hover:bg-gray-50 hover:text-gray-900 focus:ring-gray-200',
          primary:
            'bg-orange-500 text-k-h border-orange-500 hover:bg-orange-600 hover:border-orange-600 focus:ring-orange-300',
        },
        disabled: {
          true: 'cursor-not-allowed opacity-50 shadow-none active:scale-100',
        },
      },
      defaultVariants: {
        variant: 'secondary',
      },
    },
  );

  return (
    <button
      onClick={!disabled ? onClick : undefined}
      type={type}
      data-testid={testId}
      className={allotmentButton({ variant, disabled })}
    >
      {children}
    </button>
  );
}

export default function AllotmentsEditorMonthSelector({
  currentMonth,
  setCurrentMonth,
  isDisabled,
  reload,
}) {
  const { t } = useTranslation('allotments');
  const month = dayjs().month();

  return (
    <div className="flex justify-between items-center">
      <AllotmentButton
        onClick={() => {
          setCurrentMonth(currentMonth - 1);
          reload();
        }}
        disabled={isDisabled}
      >
        <i className="fal fa-arrow-left mr-1.5" />
        {formatDate(dayjs().month(currentMonth - 1), MONTH_YEAR)}
      </AllotmentButton>

      <div className="text-xs font-medium bg-gray-50 rounded-md py-2 px-8 border">
        <div className="flex space-x-1.5 items-center">
          <div>
            <i className="far fa-calendar-alt" />
          </div>

          <div
            data-testid={formatDate(dayjs().month(currentMonth), MONTH_YEAR)
              .toLowerCase()
              .split(' ')
              .join('-')}
          >
            {formatDate(dayjs().month(currentMonth), MONTH_YEAR)}
          </div>

          {!isDisabled && currentMonth !== month && (
            <>
              <div>&bull;</div>

              <button
                className="text-blue-500 font-medium border-none"
                onClick={() => setCurrentMonth(month)}
              >
                {t('monthSelector.goBack', {
                  month: formatDate(dayjs(), MONTH_YEAR),
                })}
              </button>
            </>
          )}
        </div>
      </div>

      <AllotmentButton
        testId="next-month"
        onClick={() => {
          setCurrentMonth(currentMonth + 1);
          reload();
        }}
        disabled={isDisabled}
      >
        {formatDate(dayjs().month(currentMonth + 1), MONTH_YEAR)}
        <i className="fal fa-arrow-right ml-1.5" />
      </AllotmentButton>
    </div>
  );
}
